import React from 'react';
import { HeroIntroStyleListTypes } from '../../utils/utils';
import HeroBannerImg from '../HeroBanner';
import HeroHeadlineText from '../HeroHeadlineText';
import HeroImageSlider from '../HeroImageSlider/heroImageSlider';
import TextComponent from '../TextComponent/textComponent';
import './introBanner.scss';

export default function IntroBanner({ heroBannerImage, headlineText, sliderImages, description, layoutStyle }) {
  const getLayoutSTyle = (style) => {
    switch (style) {
      case HeroIntroStyleListTypes.HEROINTROSTYLE0:
        return 'style-0';
      case HeroIntroStyleListTypes.HEROINTROSTYLE1:
        return 'style-1';
      case HeroIntroStyleListTypes.HEROINTROSTYLE2:
        return 'style-2';
      case HeroIntroStyleListTypes.HEROINTROSTYLE3:
        return 'style-3';
      default:
        return 'style-0';
    }
  };
  return (
    <div className={`hero-intro-banner ${getLayoutSTyle(layoutStyle)}`}>
      <HeroHeadlineText headlineText={headlineText} />
      {!sliderImages ? <HeroBannerImg heroBannerImage={heroBannerImage} /> : <HeroImageSlider sliderImages={sliderImages} />}
      <TextComponent description={description} />
    </div>
  );
}
